import React, {useState} from 'react'
import '../Theme.css';
import './Banner.css';
import Text from "../text/Text";
import {isDevEnv, isPrdEnv, isStgEnv} from "../../../utils/Environment";

const Banner = () => {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    const onBannerClick = () => {
        setVisible(false);
    }

    let message;
    let rootClass;
    let textClass;

    if (isDevEnv()) {
        message = "Test version. Use https://faucet.chrysalis-devnet.iota.cafe/ to receive test tokens."
        rootClass = "BannerDevRoot";
        textClass = "BannerDevText";
    }
    if (isStgEnv()) {
        message = "Test version. Use https://faucet.chrysalis-devnet.iota.cafe/ to receive test tokens."
        rootClass = "BannerStgRoot";
        textClass = "BannerStgText";
    }
    if (isPrdEnv()) {
        return null;
    }

    return (
        <div className={rootClass} onClick={onBannerClick}>
            <Text style={textClass} text={message}/>
        </div>
    )
}

export default Banner;
